<template>
  <div class="wxjk-visitor">
    <component
      :is="showComponent(item)"
      v-for="item in categoryList"
      :key="item.id"
      :item="item"
      :wxjkInfo="wxjkInfo"
    />
    <div class="footer">
      <div class="btn-wrap" @click="handleBuy" :class="{ disabled: isDisable }">
        <div class="btn-price">
          <span class="btn-unit">¥</span>
          <span>{{ wxjkInfo.payment_amount }}</span>
        </div>
        <div class="btn-text">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  watch,
} from "@vue/composition-api";

import { useStore, useRouter } from "@/components/use/base";
import { jsonSafeParse } from "@/utils";
import { getIndexCategory, getIndexClassList } from "@/apis/product";
import { queryWxjkOrder, payWxjkOrder } from "@/apis/wxjk";

import WxjkHeader from "../component/wxjk/WxjkHeader.vue";
import WxjkBenefit from "../component/wxjk/WxjkBenefit.vue";
import WxjkBenefitMore from "../component/wxjk/WxjkBenefitMore.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    WxjkHeader,
    WxjkBenefit,
    WxjkBenefitMore,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const wxjkInfo = ref({});
    const packageMap = ref({});
    const categoryList = ref([]);

    const isMember = computed(() => store.state.isMember);
    const namespace = computed(() => store.state.namespace);

    const isDisable = computed(() => {
      return wxjkInfo.value.status !== "confirmed";
    });

    const showComponent = computed(() => (item) => {
      if (item.display_code === "WxjkHeader") return "WxjkHeader";
      if (
        item.display_code === "benefitMoreimage" ||
        item.display_code === "benefitMore"
      )
        return "WxjkBenefitMore";
      return "WxjkBenefit";
    });

    watch(
      isMember,
      (newVal) => {
        if (newVal) {
          if (isMember.value) {
            router.replace("/index");
          }
        }
      },
      { immediate: true }
    );

    const initDataPage = async () => {
      packageMap.value = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const pageData = packageMap.value[namespace.value];
      if (!pageData) return;
      const { data: categoriesData } = await getIndexCategory({
        namespace: pageData.page,
        opened_page: "member",
        source: "default",
      });
      const { data: productData } = await getIndexClassList({
        title: categoriesData.map((v) => v.name).join(","),
        opened_page: "member",
        namespace: pageData.page,
      });
      categoryList.value = categoriesData
        .map((value) => ({
          ...value,
          productInfo: productData[value.name] || [],
        }))
        .filter((item) => item.display_code !== "onlineOrdering");
    };

    const initWxjk = async () => {
      if (isMember.value) return;
      const { data } = await queryWxjkOrder();
      wxjkInfo.value = data || {};
    };

    const handleBuy = async () => {
      if (isDisable.value) return;
      await payWxjkOrder();
      router.push("/wxjkPay");
    };

    onMounted(async () => {
      let loading = vm.$loading();
      try {
        await initDataPage();
        await initWxjk();
      } catch (error) {
        vm.$toast("网络繁忙请稍后重试");
      } finally {
        loading.close();
      }
    });

    return {
      showComponent,
      categoryList,
      wxjkInfo,
      isDisable,
      handleBuy,
    };
  },
});
</script>

<style lang="less" scoped>
.wxjk-visitor {
  background-color: #fff;
  padding-bottom: 106px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.07);

  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 343px;
    height: 48px;
    border-radius: 32px;
    margin: 0 auto;
    margin-top: 14px;
    background: url("https://common-h5-dev.xiangshuheika.com/static/upload/20250814b10e1804eca1f.png")
      no-repeat center center;
    background-size: 100% 100%;

    &.disabled {
      background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2025082832d7ce1206d2b.png")
        no-repeat center center;
      background-size: 100% 100%;

      .btn-text {
        color: #fff;
      }
    }

    .btn-price {
      min-width: 74px;
      font-weight: 500;
      font-size: 24px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;

      .btn-unit {
        font-size: 14px;
        margin-right: 3px;
        margin-bottom: 2px;
      }
    }

    .btn-text {
      font-weight: 600;
      font-size: 18px;
      color: #6e400e;
      line-height: 25px;
    }
  }
}
</style>
